import { Button } from "plos/src/components/buttons/Button";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { Sheet } from "plos/src/components/Sheet";
import { useTranslation } from "react-i18next";
import { whatsNextContainer, whatsNextList } from "./whatsNextSheet.css";

interface WhatsNextSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const WhatsNextSheet = ({ isOpen, onClose }: WhatsNextSheetProps) => {
  const { t } = useTranslation("pickTeam");

  return (
    <Sheet
      open={isOpen}
      handleClose={onClose}
      title={t("whatsNew.whatToDoNext", "What To Do Next?")}
      footer={
        <Button onPress={onClose} fullWidth>
          {t("whatsNew.close", "Close")}
        </Button>
      }
    >
      <div className={whatsNextContainer}>
        <p>
          {t(
            "whatsNew.lookingForGuidance",
            "Looking for guidance on what to do next?",
          )}
        </p>
        <ul className={whatsNextList}>
          <li>
            <ButtonLink
              href={`${
                import.meta.env.VITE_HF_BASE
              }/en/news/4060363/fpl-basics-explained-everything-you-need-to-know`}
              appearance="tonal"
              fullWidth
              target="_blank"
            >
              {t("whatsNew.howToPlay", "Explain how to play")}
            </ButtonLink>
          </li>
          <li>
            <ButtonLink to="/help" appearance="tonal" fullWidth target="_blank">
              {t("whatsNew.toHelpPage", "Take me to the Help Page")}
            </ButtonLink>
          </li>
          <li>
            <ButtonLink
              to="/help/rules"
              appearance="tonal"
              fullWidth
              target="_blank"
            >
              {t("whatsNew.toRulesPage", "Take me to the Rules Page")}
            </ButtonLink>
          </li>
        </ul>
      </div>
    </Sheet>
  );
};

export default WhatsNextSheet;
